

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { EmployeeAssignemnt } from "../../components/EmployeeAssignemnt/EmployeeAssignemnt";


export const EmployeeAssignemntPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Employee Assignment"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Employee Assignment", navigateTo: "/employee/assignment" }
      ]}
      mainContents={<EmployeeAssignemnt />}
    />
  );
};
